module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/img_step03-c19db8015686deae3bcc0b11bb4746f0.png";